<template>
  <v-flex xs12 row>
  	<v-layout row wrap>
  		<v-flex xs12>
  			
  		</v-flex>
  	</v-layout>

    <v-layout py-3>
   		<v-flex xs12>
   			<v-form class="invoice-form" v-model="validForm">
          <v-card>
            <v-card-title class="px-4">
              <v-flex xs7 sm4 order-xs2 order-sm1>
                <div class="subheading text-uppercase font-weight-light" v-if="invoice.code">
                  <span>ID: </span>
                  <span>{{invoice.code}}</span>
                </div>
                <div class="subheading font-weight-light" v-if="invoice.retailer">
                  <span>{{invoice.retailer.title}}</span>
                </div>
              </v-flex>
              <v-flex xs12 sm4 order-xs1 order-sm2 class="text-xs-center">
                <span class="headline text-uppercase font-weight-light pt-4" v-text="`${pageType} Proforma Invoice`"></span>
              </v-flex>
              <v-flex xs5 sm4 order-xs3 class="text-xs-right">
                <div class="body-2 font-weight-light py-2">
                  <v-icon class="mr-1">date_range</v-icon>
                  <span>{{invoice.date}}</span>
                </div>
                <div class="body-1" v-if="invoice.biller_name">
                  <span>Biller: {{invoice.biller_name}}</span>
                </div>
              </v-flex>
            </v-card-title>

            <v-card-text>
              <v-container grid-list-md class="grey lighten-5">
                
                <v-layout wrap>

                  <v-flex xs12 :class="isFranchiseeInvoice ? 'sm6' : ''" v-if="showInvoiceType">
                    <v-radio-group v-model="invoice.type" :disabled="!!invoice.id" row>
                      <v-radio label="Customer Invoice" :value="config.invoiceTypes.customer"></v-radio>
                      <v-radio label="Franchisee/Showroom Invoice" :value="config.invoiceTypes.franchisee"></v-radio>
                    </v-radio-group>
                  </v-flex>

                  <v-flex sm6 v-if="isFranchiseeInvoice">
                    <div class="subheading text-uppercase font-weight-light">
                      <span>Bill To</span>
                      <v-icon small class="mr-1" @click="franchiseeEditMode = true" v-if="invoice.franchisee && !franchiseeEditMode && !isViewMode && !isApproveMode">edit</v-icon>
                      <v-icon small class="mr-1" @click="franchiseeEditMode = false" v-if="franchiseeEditMode">done</v-icon>
                    </div>
                    <div v-if="invoice.franchisee && !franchiseeEditMode" class="py-2 px-3">
                      <div class="body-1">{{invoice.franchisee.title}}</div>
                      <div class="caption">{{invoice.franchisee.phone}}</div>
                    </div>
                    <div v-else>
                      <v-autocomplete :loading="franchiseeLoading" v-model="franchisee" :search-input.sync="franchiseeSearchText" :items="franchisees" item-text="title" item-value="id" label="Search Franchisee" hide-no-data>
                      </v-autocomplete>
                    </div>
                  </v-flex>
                  
                  <v-flex xs6 sm4 v-if="isCustomerInvoice">
                    <div class="subheading text-uppercase font-weight-light">
                      <span>Bill To</span>
                      <v-icon small class="mr-1" @click="customerEditMode = true" v-if="invoice.customer && !customerEditMode && !isViewMode && !isApproveMode">edit</v-icon>
                      <v-icon small class="mr-1" @click="customerEditMode = false" v-if="customerEditMode">done</v-icon>
                    </div>
                    <div v-if="invoice.customer && !customerEditMode" class="py-2 px-3">
                      <div class="body-1">{{invoice.customer.title}}</div>
                      <div class="caption">{{invoice.customer.mobile}}</div>
                      <div class="caption" v-if="invoice.customer.address1">{{invoice.customer.address1}}</div>
                      <div class="caption" v-if="invoice.customer.address2">{{invoice.customer.address2}}</div>
                    </div>
                    <div v-else>
                      <v-autocomplete :loading="customerLoading" v-model="customer" :search-input.sync="customerSearchText" :items="customers" item-text="title" item-value="id" label="Search Customer" hide-no-data append-icon="add" @click:append="openCustomerForm">
                        <template slot="item" slot-scope="data">
                          <v-list-tile-content>
                            <v-list-tile-title v-text="data.item.title"></v-list-tile-title>
                            <v-list-tile-sub-title class="caption" v-text="data.item.mobile"></v-list-tile-sub-title>
                          </v-list-tile-content>
                        </template>
                      </v-autocomplete>
                    </div>
                  </v-flex>

                  <v-flex xs6 sm4 v-if="isCustomerInvoice">
                    <div class="subheading text-uppercase font-weight-light">
                      <span>LTP</span>
                      <v-icon small class="mr-1" @click="agentEditMode = true" v-if="invoice.agent && invoice.agent.id && !agentEditMode && !isViewMode && !isApproveMode">edit</v-icon>
                      <v-icon small class="mr-1" @click="agentEditMode = false" v-if="agentEditMode">done</v-icon>
                    </div>
                    <div v-if="invoice.agent && invoice.agent.id && !agentEditMode" class="py-2 px-3">
                      <div class="body-1">{{invoice.agent.title}}</div>
                      <div class="caption">{{invoice.agent.mobile}}</div>
                      <div class="caption">LTP No.: {{invoice.agent.id}}</div>
                    </div>
                    <div v-else-if="!isViewMode && !isApproveMode">
                      <v-autocomplete :loading="agentLoading" v-model="agent" :search-input.sync="agentSearchText" :items="agents" item-text="id" item-value="id" label="Search LTP Code" hide-no-data append-icon="add" @click:append="openAgentForm">
                        <template slot="item" slot-scope="data">
                          <v-list-tile-content>
                            <v-list-tile-title v-text="data.item.title"></v-list-tile-title>
                            <v-list-tile-sub-title class="caption" v-text="data.item.mobile"></v-list-tile-sub-title>
                          </v-list-tile-content>
                        </template>
                      </v-autocomplete>
                    </div>
                  </v-flex>

                  <v-flex xs6 sm4 v-if="isCustomerInvoice">
                    <div class="subheading text-uppercase font-weight-light">
                      <span>Care of</span>
                      <v-icon small class="mr-1" @click="executiveEditMode = true" v-if="invoice.executive && !executiveEditMode && !isViewMode && !isApproveMode">edit</v-icon>
                      <v-icon small class="mr-1" @click="executiveEditMode = false" v-if="executiveEditMode">done</v-icon>
                    </div>
                    <div v-if="invoice.executive && !executiveEditMode" class="py-2 px-3">
                      <div class="body-1">{{invoice.executive.first_name}}</div>
                      <div class="caption">{{invoice.executive.mobile}}</div>
                    </div>
                    <div v-else>
                      <v-autocomplete :loading="executiveLoading" v-model="executiveId" :search-input.sync="executiveSearchText" :items="executives" item-text="first_name" item-value="id" label="Search Staff" hide-no-data>
                        <template slot="item" slot-scope="data">
                          <v-list-tile-content>
                            <v-list-tile-title v-text="data.item.first_name"></v-list-tile-title>
                            <v-list-tile-sub-title class="caption" v-text="data.item.mobile"></v-list-tile-sub-title>
                          </v-list-tile-content>
                        </template>
                      </v-autocomplete>
                    </div>
                  </v-flex>

                </v-layout>

              </v-container>

              <v-container grid-list-md py-0 v-if="!isViewMode">

                <v-layout wrap>
                  <v-flex xs5 sm3>

                    <autocomplete
                      async
                      label="Search Item Code"
                      ref="itemCodeSearch"
                      search-key="item_code"
                      sub-title="category_name"
                      v-model="itemId"
                      :api-path="config.apis.searchItems"
                      @selected="upsertItemToInvoiceByCode"
                    />
                  </v-flex>
                  <v-flex xs7 sm6>
                    <autocomplete
                      async
                      label="Search Item Name"
                      ref="itemNameSearch"
                      search-key="title"
                      sub-title="category_name"
                      v-model="itemId"
                      :api-path="config.apis.searchItems"
                      @selected="upsertItemToInvoiceByName"
                    />
                  </v-flex>
                  <v-flex xs12 sm3 class="pl-5">
                    <v-switch v-model="taxEnabled" @change="updateTax" label="Include GST" :disabled="isViewMode || isApproveMode"></v-switch>
                  </v-flex>
                </v-layout>
              </v-container>

              <v-container>
                <v-layout wrap>
                  <v-flex xs12>
                    <div>
                      <div class="v-table__overflow">
                        <table class="v-datatable v-table">
                          <thead>
                            <tr>
                              <th role="columnheader" scope="col" class="column text-xs-left">
                                <span>Sl.</span>
                              </th>
                              <th role="columnheader" scope="col" class="column text-xs-left">
                                <span>Item Code</span>
                              </th>
                              <th role="columnheader" scope="col" class="column text-xs-left" v-if="!isMobileApp">
                                <span>Item Name</span>
                              </th>
                              <th role="columnheader" scope="col" class="column text-xs-left">
                                <span>Unit</span>
                              </th>
                              <th role="columnheader" scope="col" class="column text-xs-right" v-if="showPrice">
                                <span>Rate ({{currency}})</span>
                              </th>
                              <th role="columnheader" scope="col" class="column" :class="isViewMode ? 'text-xs-right' : 'text-xs-left'">
                                <span>QTY</span>
                              </th>
                              <th role="columnheader" scope="col" class="column text-xs-right" v-if="isApproveMode">
                                <span>Stock QTY</span>
                              </th>
                              <th role="columnheader" scope="col" class="column text-xs-right" v-if="showPrice">
                                <span>Tax (%)</span>
                              </th>
                              <th role="columnheader" scope="col" class="column text-xs-right" v-if="showPrice">
                                <span>Amount ({{currency}})</span>
                              </th>
                              <th role="columnheader" scope="col" class="column text-xs-right" v-if="!isViewMode">
                                <span>Actions</span>
                              </th>
                            </tr>
                          </thead>
                          <tbody v-if="invoice.items && invoice.items.length > 0">
                            <tr is="invoice-item" v-for="(item, index) in invoice.items" v-bind:item="item" v-bind:index="index" v-on:delete="deleteItem" :viewMode="isViewMode" :approveMode="isApproveMode" :showPrice="showPrice"></tr>
                          </tbody>
                          <tbody v-else>
                            <tr>
                              <td colspan="8">No Items Added</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </v-flex>
                  <v-flex xs12 sm6 md8 v-if="showPrice">
                    <v-layout class="align-start justify-end column fill-height pr-3">
                      <div class="body-2" v-if="amountInWords">
                        <span class="grey--text text--darken-2">Total Amount (In Words): </span>
                        <span class="font-weight-light">{{amountInWords}}</span>
                      </div>
                      <div class="body-2" v-if="(extra_discount > 0) || (isViewMode && invoice.extra_discount > 0)">
                        <span class="grey--text text--darken-2">Extra Discount Narration: </span>
                        <span class="font-weight-light">{{extraDiscountNarration}}</span></div>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm6 md4 class="text-xs-right justify-end py-3 pl-3 pr-3" v-if="showPrice">
                    <table class="total-table">
                      <tbody>
                        <tr class="body-2">
                          <td width="66%">Subtotal ({{currency}}): </td>
                          <td width="34%">{{ isViewMode ? invoice.subtotal : subtotal | roundValue }}</td>
                        </tr>
                        <tr class="body-1" v-if="!isViewMode">
                          <td>
                            <v-icon v-if="isFranchiseeInvoice" small class="mr-1" @click="discountEditMode = true">edit</v-icon>
                            Discount (<span>{{ discount_percent }}</span>%): 
                          </td>
                          <td>
                            <span v-if="discount > 0">-</span>{{ discount | roundValue }}
                          </td>
                        </tr>
                        <tr class="body-1" v-else-if="invoice.discount > 0">
                          <td>Discount (<span>{{ invoice.discount_percent }}</span>%):</td>
                          <td><span>-</span>{{ invoice.discount | roundValue }}</td>
                        </tr>
                        <tr class="body-1" v-if="!isViewMode">
                          <td>
                            <v-icon small class="mr-1" @click="extraDiscountEditMode = true">edit</v-icon>
                            Extra Discount (<span>{{ extra_discount_percent }}</span>%): 
                          </td>
                          <td>
                            <span v-if="extra_discount > 0">-</span>{{ extra_discount | roundValue }}
                          </td>
                        </tr>
                        <tr class="body-1" v-else-if="invoice.extra_discount > 0">
                          <td>Extra Discount (<span>{{ invoice.extra_discount_percent }}</span>%):</td>
                          <td><span>-</span>{{ invoice.extra_discount | roundValue }}</td>
                        </tr>
                        <tr class="body-1">
                          <td>Roundoff ({{currency}}): </td>
                          <td v-if="isViewMode">{{ invoice.round_off | roundValue }}</td>
                          <td v-else>
                            <v-edit-dialog color="white" :return-value.sync="round_off" lazy @open="openRoundOff" @close="closeRoundOff" class="text-xs-right justify-end"> {{ invoice.round_off | roundValue }}
                              <v-text-field type="number" :rules="roundOffRules" slot="input" v-model="round_off" label="Enter Amount" single-line></v-text-field>
                            </v-edit-dialog>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <v-divider class="my-2"></v-divider>
                    <table class="total-table">
                      <tbody>
                        <tr class="body-1 font-weight-medium" v-if="tax > 0">
                          <td width="66%">Total Amount ({{currency}}): </td>
                          <td width="34%">{{ isViewMode ? invoice.total : total | roundValue }}</td>
                        </tr>
                        <tr class="body-1 font-weight-medium" v-if="tax > 0">
                          <td width="66%">GST ({{ invoice.tax_percent }}%): </td>
                          <td width="34%">{{ isViewMode ? invoice.tax : tax | roundValue }}</td>
                        </tr>
                        <tr class="subheading font-weight-medium">
                          <td width="66%">Grand Total ({{currency}}): </td>
                          <td width="34%">{{ isViewMode ? invoice.grandtotal : grandtotal | roundValue }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </v-flex>
                </v-layout>
              </v-container>

            </v-card-text>

            <v-card-actions v-if="!isViewMode">
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat :disabled="processing" :to="cancelLink">Cancel</v-btn>
              <v-btn v-if="isApproveMode" color="blue darken-1" flat :disabled="!validForm || processing || !hasEnoughStock" :loading="processing" @click.native="openConfirmDialog" v-text="'Approve'"></v-btn>
              <v-btn v-else-if="!invoice.id || isEditMode" color="blue darken-1" flat :disabled="!validForm || processing" :loading="processing" @click.native="upsertInvoice" v-text="invoice.id ? 'Update' : 'Save'"></v-btn>
            </v-card-actions>
          </v-card>
        </v-form>

        <customer-form v-bind:active.sync="customerDialog" @success="addCustomerToInvoice" v-if="!isViewMode && !isApproveMode" />
        <agent-form v-bind:active.sync="agentDialog" @success="addAgentToInvoice" v-if="!isViewMode && !isApproveMode" />
		    <action-dialog action="approve" :status="confirmDialog" @close="closeConfirmDialog" @success="upsertInvoice" />

        <v-dialog v-model="extraDiscountEditMode" max-width="400px">
            <v-card>
              <v-card-title>
                <span class="headline">Select Extra Discount</span>
              </v-card-title>

              <v-card-text>
                <v-container grid-list-md py-0>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-autocomplete :rules="requireRule" v-model="extra_discount_ref_id" :items="extra_discounts" item-text="title" item-value="id" label="Extra Discount">
                        <template slot="item" slot-scope="data">
                          <v-list-tile-content>
                            <v-list-tile-title v-text="data.item.title"></v-list-tile-title>
                            <v-list-tile-sub-title class="caption" v-text="`Extra Discount: ${data.item.discount_percent}%`"></v-list-tile-sub-title>
                          </v-list-tile-content>
                        </template>
                      </v-autocomplete>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click="extraDiscountEditMode = false">Close</v-btn>
              </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="discountEditMode" max-width="300px">
            <v-card>
              <v-card-title>
                <span class="headline">Discount Percent</span>
              </v-card-title>

              <v-card-text>
                <v-container grid-list-md py-0>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-text-field v-if="invoice.id" key="invoice-discount-input" type="number" v-model="invoice.discount_percent" label="Percentage"></v-text-field>
                      <v-text-field v-else type="number" key="franchisee-discount-input" v-model="franchisee_discount_percent" label="Percentage"></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click="discountEditMode = false">Close</v-btn>
              </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="newItemQtyPopUp" max-width="300px">
            <v-card>
              <v-card-title>
                <span class="headline">Item Quantity</span>
              </v-card-title>

              <v-card-text>
                <v-container grid-list-md py-0>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-text-field ref="lastItemQtyInput" type="number" v-model="last_item_quantity" label="Quantity"></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click="updateNewItemQty">Update</v-btn>
              </v-card-actions>
            </v-card>
        </v-dialog>

   		</v-flex>
   	</v-layout>
    
  </v-flex>
</template>

<script>
  
  import differenceBy from 'lodash/differenceBy'

  import InvoiceItem from './InvoiceItem'
  import CustomerForm from './CustomerCreate'
  import AgentForm from './AgentCreate'

  export default {
    name: 'Invoice',
    props: {
      viewMode: {
        default: false
      },
      approveMode: {
        default: false
      }
    },
    data () {
      return {
      	title: "Invoice",
        validForm: false,
      	processing: false,
        customerDialog: false,
        agentDialog: false,
        agentEditMode: false,
        customerEditMode: false,
        franchiseeEditMode: false,
        customerLoading: false,
        franchiseeLoading: false,
        agentLoading: false,
        confirmDialog: false,
        customers: [],
        franchisees: [],
        customerSearchText: "",
        franchiseeSearchText: "",
        customer: "",
        franchisee: "",
        agents: [],
        agentSearchText: "",
        agent: "",
        itemId: null,
        executives: [],
        executiveLoading: false,
        executiveEditMode: false,
        executiveSearchText: "",
        executiveId: null,
        taxEnabled: false,
        extra_discounts: [],
        extraDiscountEditMode: false,
        extra_discount_ref_id: null,
        extra_discount_percent: 0,
        discountEditMode: false,
        franchisee_discount_percent: 0,
        customer_discount_percent: 0,
        round_off: 0,
        invoice: {},
        defaultInvoice: {
          id: "",
          date: this.today('Do MMM, YYYY'),
          customer: null,
          franchisee: null,
          agent: null,
          items: [],
          round_off: 0,
          tax_percent: 0,
          tax: 0,
          retailer: null,
          executive: null,
          type: 1
        },
        newItemQtyPopUp: false,
        last_item_quantity: 1,
        nameRules: [
            v => !!v || 'Name is required',
            v => v && v.length >= 4 || 'Must be more than 3 characters',
            v => v && v.length <= 50 || 'Maximum 50 characters allowed'
        ],
        requireRule: [
          v => !!v || 'Field is required'
        ],
        codeRules: [
            v => !!v || 'Item code is required',
            v => v && v.length >= 4 || 'Must be more than 3 characters',
            v => v && v.length <= 20 || 'Maximum 20 characters allowed'
        ],
        rateRules: [
            v => !!v || 'Rate is required',
            v => /^([0-9]{2,7})$/.test(v) || 'Rate must be valid'
        ],
        roundOffRules: [
          v => !!v || 'Amount is required',
          v => /^-?\s*(?=.*[0-9])\d*(?:\.\d{1,2})?\s*$/.test(v) || 'Amount must be valid'
        ],
        lastItemSearchBy: 'Code',

      }
    },
    created () {

      	let breadcrumbs = [
	      	{
	          text: 'Dashboard',
	          disabled: false,
	          href: '/dashboard'
	        },
	        {
	          text: 'Proforma Invoice',
            disabled: false,
            href: '/proforma-invoice-list'
	        },
	        {
	          text: this.pageType,
	          disabled: true
	        }
       ]

      this.$store.commit('setBreadcrumbs', breadcrumbs)
      this.$store.commit('setPageTitle', 'Manage Proforma Invoice')
    },
    methods: {

      searchCustomers () {
        this.customerLoading = true
        this.axios.get(`${this.config.apis.searchCustomers}?title=${this.customerSearchText}`)
        .then((response) => {
            this.customerLoading = false
            if (this.isSuccessResponse(response)) {
              this.customers = response.data.data
            }
        })
        .catch((error) => {
            this.customerLoading = false
        })
      },

      searchFranchisees () {
        this.franchiseeLoading = true
        this.axios.get(`${this.config.apis.searchRetailers}?title=${this.franchiseeSearchText}`)
        .then((response) => {
            this.franchiseeLoading = false
            if (this.isSuccessResponse(response)) {
              this.franchisees = response.data.data
            }
        })
        .catch((error) => {
            this.franchiseeLoading = false
        })
      },

      searchAgents () {
        this.agentLoading = true
        this.axios.get(`${this.config.apis.searchAgents}?id=${this.agentSearchText}`)
        .then((response) => {
            this.agentLoading = false
            if (this.isSuccessResponse(response)) {
              this.agents = response.data.data
            }
        })
        .catch((error) => {
            this.agentLoading = false
        })
      },

      searchExecutives () {
        let api_path = this.config.apis.searchExecutives
        if (this.executiveSearchText) {
          api_path += `?first_name=${this.executiveSearchText}`
        }

        this.executiveLoading = true
        this.axios.get(api_path)
        .then((response) => {
            this.executiveLoading = false
            if (this.isSuccessResponse(response)) {
              this.executives = response.data.data
            }
        })
        .catch((error) => {
            this.executiveLoading = false
        })
      },

      getExtraDiscounts () {
        
        this.getAllData('extradiscount')
          .then((response) => {
              this.extra_discounts = response
          })

      },

      upsertItemToInvoiceByCode (selected) {
        this.lastItemSearchBy = 'Code'
        this.upsertItemToInvoice(selected)
      },

      upsertItemToInvoiceByName (selected) {
        this.lastItemSearchBy = 'Name'
        this.upsertItemToInvoice(selected)
      },

      upsertItemToInvoice (selected) {

        let exist = this.invoice.items.findIndex(item => item.item_id === selected.id)

        // if item already exists, then increase quantity else add new item
        if (exist !== -1) {
          this.invoice.items[exist].quantity++
        }
        else{

            selected.tax = ( ( selected.rate * selected.tax_percent ) / 100)
            //add new item at the first index of items array
            let new_item = this.extend({ quantity: 1, total: 0, item_id: selected.id }, selected)
            delete new_item.id
            this.invoice.items.push(new_item)
            this.showNewItemQtyPopUp()
        }
    
        this.clearItemAutoComplete()
      },

      clearItemAutoComplete () {
        setTimeout(() => {
          this.itemId = null
        }, 100)
      },

      calculateItemTotal (item) {
        return item.quantity * ( item.rate + ( ( item.rate * item.tax_percent ) / 100) )
      },

      updateTax () {
        this.invoice.tax_percent = this.taxEnabled ? this.tax_percent : 0
      },

      upsertInvoice () {

        if (this.invoice.items.length === 0) return this.notifyError('emptyInvoiceItems')
        if (this.isCustomerInvoice && !this.invoice.customer) return this.notifyError('emptyInvoiceCustomer')
        if (this.isFranchiseeInvoice && !this.invoice.franchisee) return this.notifyError('emptyInvoiceFranchisee')
        if (this.total < 0) return this.notifyError('invalidInvoiceTotal')

        this.processing = true

        let data = this.extend(this.invoice, {
          retailer: this.retailerId,
          discount: this.discount,
          discount_percent: this.discount_percent,
          extra_discount_ref_id: this.extra_discount_ref_id,
          extra_discount: this.extra_discount,
          extra_discount_percent: this.extra_discount_percent,
          total: this.total,
          subtotal: this.subtotal,
          tax: this.tax,
          tax_percent: this.invoice.tax_percent,
          grandtotal: this.grandtotal
        })

        let method = data.id ? 'put' : 'post'
        let api_path = data.id ? ( this.isApproveMode ? this.config.apis.approveInvoice.replace(":id", data.id) : this.config.apis.updateInvoice.replace(":id", data.id) ) : this.config.apis.saveInvoice

        this.axios[method](api_path, data)
          .then((response) => {
            if (this.isSuccessResponse(response)) {

              let successStatus = data.id ? 'updateInvoiceSuccess' : 'insertInvoiceSuccess'

              this.notifySuccess(successStatus)
              this.$router.push(this.isApproveMode ? "/sales-list" : "/proforma-invoice-list")
            }
            else{

              let errorStatus = data.id ? 'updateError' : 'insertError'

              this.notifyError(errorStatus)
            }
            this.processing = false
          })
          .catch((error) => {
            this.processing = false
          })
      },

      deleteItem (index) {
        this.invoice.items.splice(index, 1)
      },

      initNewInvoice () {
        this.invoice = this.extend({}, this.defaultInvoice)
      },

      loadInvoice (invoiceCode) {
        this.processing = true
        
        let api_path = this.config.apis.getInvoice.replace(":code", invoiceCode)

            api_path = this.approveMode ? `${api_path}?approveMode=true` : api_path

        this.axios.get(api_path)
          .then((response) => {
            this.processing = false
            if (this.isSuccessResponse(response)) {
              this.invoice = response.data.data
              this.taxEnabled = this.invoice.tax_percent > 0
              this.extra_discount_ref_id = response.data.data.extra_discount_ref_id
            }
            else{
              this.invoice = this.initNewInvoice()
            }
          })
          .catch((error) => {
            this.processing = false
          })
      },

      openCustomerForm () {
        this.customerDialog = true
      },

      openAgentForm () {
        this.agentDialog = true
      },

      addCustomerToInvoice (customer) {
        this.customers = [customer]
        this.customer = customer.id
      },

      addAgentToInvoice (agent) {
        this.agents = [agent]
        this.agent = agent.id
      },

      openRoundOff () {
        this.round_off = parseFloat(this.invoice.round_off)
      },

      closeRoundOff () {
        this.invoice.round_off = parseFloat(this.round_off ? this.round_off : this.invoice.round_off)
      },

      setDefaultExtraDiscount () {
        if (this.extra_discounts.length > 0) {
          this.extra_discount_ref_id = this.extra_discounts[0].id
          this.extra_discount_percent = this.extra_discounts[0].discount_percent
        }
        else{
          this.extra_discount_ref_id = null
          this.extra_discount_percent = 0
        }
      },

      openConfirmDialog () {
        this.confirmDialog = true
      },

      closeConfirmDialog () {
        this.confirmDialog = false
      },

      showNewItemQtyPopUp () {
      	this.newItemQtyPopUp = true
      	this.$nextTick(this.$refs.lastItemQtyInput.focus)
      },

      updateNewItemQty () {
      	let item = this.invoice.items[this.invoice.items.length - 1]
      	item.quantity = this.last_item_quantity
      	this.newItemQtyPopUp = false
      	this.last_item_quantity = 1
      	
      	setTimeout(() => {
      		this.$refs[`item${this.lastItemSearchBy}Search`].$el.querySelector('input').focus()
      	}, 100)
      	
      },

    },
    mounted () {

    	this.franchisee_discount_percent = this.appSettings.franchisee_discount_percent.option_value
        this.customer_discount_percent = this.appSettings.customer_discount_percent.option_value

      	this.getAllData('extradiscount')
          	.then((response) => {
              
              this.extra_discounts = response

              if (this.$route.params.invoiceCode) {
                this.loadInvoice(this.$route.params.invoiceCode)
              }
              else{
                this.initNewInvoice()
              }

          	})
      
    },

    computed: {

      subtotal () {
        
        let total = 0
        
        if (this.invoice.items) {
          this.invoice.items.forEach( item => {
            total += item.total
          })
        }
        
        return total
      },

      total () {
        return ( this.subtotal + this.invoice.round_off ) - ( this.discount + this.extra_discount )
      },

      tax () {
        return this.total * this.invoice.tax_percent / 100
      },

      grandtotal () {
        return this.tax + this.total
      },

      discount () {
        return ( this.subtotal * this.discount_percent ) / 100
      },

      extra_discount () {
        return ( (this.subtotal - this.discount) * this.extra_discount_percent ) / 100
      },

      pageType () {
        
        let title = "Add"
        
        if (this.isViewMode) {
          title = "View"
        }
        else if(this.isApproveMode) {
          title = "Approve"
        }
        else if(this.$route.params.invoiceCode) {
          title = "Edit"
        }

        return title

      },

      extraDiscountNarration () {
        
        if (!this.extra_discount_ref_id) return ""

        let narration = ""
        let discount = this.extra_discounts.filter( item => item.id === this.extra_discount_ref_id )

        if (discount.length > 0) {
          narration = discount[0].title
        }
        return narration
      },

      amountInWords () {
        return this.amountToWords(this.grandtotal)
      },

      discount_percent () {
        if (this.invoice.id) {
          return this.invoice.discount_percent
        }
        return this.invoice.type == this.config.invoiceTypes.customer ? this.customer_discount_percent : this.franchisee_discount_percent
      },

      tax_percent () {
        return this.appSettings && this.appSettings.tax_percent ? 
                this.appSettings.tax_percent.option_value : 0
      },

      isFranchiseeInvoice () {
        return this.invoice.type == this.config.invoiceTypes.franchisee
      },

      isCustomerInvoice () {
        return this.invoice.type == this.config.invoiceTypes.customer
      },

      showInvoiceType () {
        return this.retailerId == this.config.retailers.mainBranch && ( this.hasAdminPrivilage || this.isSalesManager || this.isBillingStaff )
      },

      hasEnoughStock () {
        
        if (!this.isApproveMode || !this.invoice.items) return true

        let stockLessItems = this.invoice.items.filter( item => item.quantity > item.stock_quantity )

        return stockLessItems.length > 0 ? false : true

      },

      filteredSearchItems () {
      	if (!this.invoice.items) return []
    		let invoiceItems = this.invoice.items.map(item => {
    			return {
    				id: item.item_id
    			}
    		})
      	return differenceBy(this.searchItems, invoiceItems, 'id')
      },

      showPrice () {
        return this.hasAdminPrivilage || this.isSalesManager || this.isBillingStaff || this.isAccountsStaff || this.isCommissionManager
      },

      cancelLink () {
      	return this.isApproveMode ? '/sales-list' : '/proforma-invoice-list'
      },

      isViewMode () {
        return this.viewMode || this.invoice.status === this.config.invoiceStatus.approved || this.invoice.status === this.config.invoiceStatus.shipped || this.invoice.status === this.config.invoiceStatus.delivered || this.invoice.status === this.config.invoiceStatus.cancelled
      },

      isApproveMode () {
        return this.approveMode && this.invoice.status == this.config.invoiceStatus.confirmed
      },

      isEditMode () {
        return this.invoice.status == this.config.invoiceStatus.pending
      }

    },

    watch: {

      '$route' (to, from) {
        // react to route changes...
        if (to !== from && to.params.invoiceCode) {
          this.loadInvoice(to.params.invoiceCode)
        }
        else{
          this.invoice = this.initNewInvoice()
        }

      },
      
      customerSearchText (val, oldVal) {
        if (val && val != oldVal) {
          this.searchCustomers()
        }
      },
      
      franchiseeSearchText (val, oldVal) {
        if (val && val != oldVal) {
          this.searchFranchisees()
        }
      },

      agentSearchText (val, oldVal) {
        if (val && val != oldVal && val != this.agent) {
          this.searchAgents()
        }
      },

      customer (val, oldVal) {
        let customer = this.customers.filter( item => val == item.id )

        if (customer.length > 0) {
          this.invoice.customer = customer[0]
          this.customerEditMode = false
        }
        else{
          this.invoice.customer = null
        }

      },

      franchisee (val, oldVal) {
        let franchisee = this.franchisees.filter( item => val == item.id )

        if (franchisee.length > 0) {
          this.invoice.franchisee = franchisee[0]
          this.franchiseeEditMode = false
        }
        else{
          this.invoice.franchisee = null
        }

      },

      agent (val, oldVal) {
        let agent = this.agents.filter( item => val == item.id )

        if (agent.length > 0) {
          this.invoice.agent = agent[0]
          this.agentEditMode = false
        }
        else{
          this.invoice.agent = null
        }
      },

      executiveSearchText (val, oldVal) {
        if (val && val != oldVal) {
          this.searchExecutives()
        }
      },

      executiveId (val, oldVal) {
        let executive = this.executives.filter( item => val == item.id )

        if (executive.length > 0) {
          this.invoice.executive = executive[0]
          this.executiveEditMode = false
        }
        else{
          this.invoice.executive = null
        }

      },

      extra_discount_ref_id (val, oldVal) {
        if (!val) {
          this.setDefaultExtraDiscount()
        }
        else{
          let discount = this.extra_discounts.filter( item => item.id === val )
          if (discount.length > 0) {
            this.extra_discount_percent = discount[0].discount_percent
          }
          else{
            this.setDefaultExtraDiscount()
          }
        }
      },

      franchisee_discount_percent (val) {
      	if (!val || val < 0 || val > 100) {
      		this.franchisee_discount_percent = 0
      	}
      },

      'invoice.round_off' (val, oldVal) {
        if (!val) {
          this.invoice.round_off = 0
        }
      },

      'invoice.type' (val, oldVal) {
        if (val) {
          if (val == this.config.invoiceTypes.customer) {
            this.franchisee = ""
          }
          else{
            this.customer = ""
            this.agent = ""
            this.executiveId = null
          }
        }
      }

    },
    
    components: {
      'invoice-item': InvoiceItem,
      'customer-form': CustomerForm,
      'agent-form': AgentForm
    }

  }
</script>

<style scoped>
  .mobile-app .invoice-form .v-card__title {
    padding: 12px !important;
  }
  .mobile-app .invoice-form .v-card__text {
    padding: 0;
  }
</style>
